import { BillToAddress } from "./bill-to-address";

export class BillTo {
    name: string;
    account: string;
    address: BillToAddress;
    street: string;
    city: string;
    postalCode: string;
    region: string;
    country: string;
    salesOrg: string;
    division: string;
    distChannel: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/bill-to.ts